import {PillTone} from "../Modules/Dashboard/Unavailability/Pill";

export const normalizePerformanceRatio = (value: number | null | undefined): number => {
    if (value === null || value === undefined || value < 0) return 0;
    return value;
};

export const getPerformanceRatioTone = (value: number | null | undefined): PillTone => {
    const normalized = normalizePerformanceRatio(value);
    if (normalized >= 70 && normalized <= 95) return "prGood";
    if (normalized >= 60 || normalized > 95) return "prWarning";
    return "prBad";
};

export const formatPerformanceRatio = (value: number | null | undefined): string => {
    const normalized = normalizePerformanceRatio(value);
    return normalized.toFixed(1).replace(".", ",");
};

export const formatAvailability = (value: number | null | undefined): string => {
    if (value === null || value === undefined) return "-";
    return value.toFixed(1).replace(".", ",");
};
